<template>
  <el-card class="box-card" shadow="always">
    <div slot="header" class="clearfix user-header">
      <span><i class="el-icon-user-solid"></i> {{$t('user.userInfo.user')}}</span>
      <span style="color: #409EFF">{{$t('user.userInfo.edit')}}</span>
    </div>
    <el-form :model="userForm" :rules="rules" ref="userForm" label-width="120px" class="demo-ruleForm">
      <el-form-item :label="$t('user.userInfo.form.username')" prop="username">
        <el-input size="small" v-model="userForm.username"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.userInfo.form.email')" prop="email">
        <el-input size="small" v-model="userForm.email"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.userInfo.form.password')" prop="password">
        <el-input size="small" v-model="userForm.password" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.userInfo.form.role')" prop="role">
        <el-select v-model="userForm.role" size="small" placeholder="Роли">
          <el-option
            v-for="item in roles"
            :key="item.value"
            :label="item.title"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('user.userInfo.form.group')" prop="group">
        <el-input size="small" v-model="userForm.group"></el-input>
      </el-form-item>
      <el-form-item label="Кол-во лент" prop="max_threads">
        <el-input size="small" v-model="userForm.max_threads" @input="handleChangeThreads"></el-input>
      </el-form-item>
      <el-form-item label="Город" prop="map_center" v-if="isAdmin">
        <el-input size="small" v-model="userForm.map_center"></el-input>
      </el-form-item>
      <el-form-item prop="manage_keywords" v-if="isAdmin">
        <el-checkbox v-model="userForm.manage_keywords" label="Доступ к редактированию ключевых слов"></el-checkbox>
      </el-form-item>
      <el-divider></el-divider>
      <div class="user-card-footer">
        <el-button
          size="medium"
          type="success"
          @click="handleEdit('userForm')">Сохранить</el-button>
        <el-button
          size="medium"
          type="danger"
          @click="beforeDelete(user.$index, user.row)">Удалить</el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
  // components
  import notify from "../../../../helpers/notify";

  // store
  import {CHANGE_USER, DELETE_USER} from "../../../../store/actions/users";
  import {mapGetters} from 'vuex';

  export default {
    name: 'UserInfo',
    props: {
      user: {
        type: Object
      }
    },
    data() {
      return {
        userForm: {},
        maxThreadsOriginal: this.user.row.max_threads,
        roles: this.$t('user.roles'),
        rules: this.$t('user.rules'),
      };
    },
    computed: {
      ...mapGetters([
        'isAdmin',
      ]),
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      handleChangeThreads(value) {
        const maxThreadsLimit  = 65535;
        if (this.userForm.max_threads) {
          this.userForm.max_threads = parseInt(value);
          if (this.userForm.max_threads > maxThreadsLimit) {
            this.userForm.max_threads = maxThreadsLimit;
          }
        } else {
          this.userForm.max_threads = 0;
        }
      },
      handleEdit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.userForm.group = Number(this.userForm.group);

            if (this.userForm.max_threads == this.maxThreadsOriginal) {
              this.userForm.max_threads = null;
            }

            this.$store.dispatch(CHANGE_USER, this.userForm).then(() => {
              notify.call(this, "Пользователь сохранен", "success");
            }).catch(() => {
              notify.call(this, "Ошибка сервера", "error");
            });
          } else {
            notify.call(this, "Поля формы заполнены неверно", "error");
            return false;
          }
        });
      },
      beforeDelete(index, row) {
        this.$alert(`Удалить пользователя ${row.username}?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.handleDelete();
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      handleDelete() {
        this.$store.dispatch(DELETE_USER, this.user.row.uid).then(() => {
          notify.call(this, "Пользователь удален", "success");
        }).catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        });
      },
    },
    mounted() {
      this.maxThreadsOriginal = this.user.row.max_threads
      this.userForm = {...this.userForm, ...this.user.row, password: ''};
    },
  };
</script>

<style>
  .user-header {
    display: flex;
    justify-content: space-between;
  }
  .user-card-footer {
    display: flex;
    justify-content: space-between;
  }
</style>
